module.exports = __webpack_public_path__ + "img/zx_new_logo.ae08a0de.png";